var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUserIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_808_467)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.439 12.6935C9.97306 12.6935 7.96729 10.6866 7.96729 8.2212C7.96729 5.75524 9.97306 3.75 12.439 3.75C14.9055 3.75 16.9108 5.75524 16.9108 8.2212C16.9108 10.6866 14.905 12.6935 12.439 12.6935ZM12.439 4.96443C10.6434 4.96443 9.18226 6.42563 9.18226 8.2212C9.18226 10.0173 10.6434 11.4785 12.439 11.4785C14.2351 11.4785 15.6963 10.0173 15.6963 8.2212C15.6963 6.42563 14.2346 4.96443 12.439 4.96443Z",
    fill: "#565656"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.27467 19.4314C5.20586 19.4314 5.13651 19.4201 5.06877 19.3954C4.7532 19.283 4.58869 18.9347 4.70266 18.6191C5.87248 15.3656 8.98087 13.1797 12.4387 13.1797C15.8965 13.1797 19.0049 15.3656 20.1753 18.6191C20.2876 18.9341 20.1237 19.283 19.8086 19.3954C19.4931 19.5088 19.1442 19.3443 19.0307 19.0293C18.034 16.258 15.3853 14.3952 12.4387 14.3952C9.49213 14.3952 6.84338 16.258 5.84614 19.0293C5.75743 19.2771 5.52358 19.4314 5.27467 19.4314Z",
    fill: "#565656"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_808_467"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white",
    transform: "translate(1 1)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIcon);
export default __webpack_public_path__ + "static/media/userIcon.b8d68ae8.svg";
export { ForwardRef as ReactComponent };